import Missions from '../components/Missions/Mission';

const MissionsPage = () => (
  <div>
    <Missions />
  </div>
);
export default MissionsPage;
